import {Integration} from "@/shared/timr";
import {Integrations} from "./integrations";
import * as BootstrapModal from "@/shared/ui/bootstrapModal";
import {IntegrationType} from "@/shared/timrTypes";

export class AddIntegrationDialogHandler {
	private modal: BootstrapModal.Modal;

	constructor() {
		this.initDialog();
		this.initListeners();
	}

	public show(enabledIntegrations: Integration[]) {
		for (const i of enabledIntegrations) {
			if (!i.multiInstance) {
				$(`[data-integration-type="${i.type}"]`).hide();
				$(`[aria-added="${i.type}"]`).show();
			}
		}
		this.modal.show();
	}

	private initDialog() {
		this.modal = new BootstrapModal.Modal({
			title: messages["integrations.add.integration"],
			message: $("#addIntegrationDialog"),
			buttons: [{
				text: messages["dialog.cancel"],
				action: modal => modal.close(),
				css: "btn-default"
			}],
			onClose: () => {
				this.resetDialog();
			}
		});
	}

	private initListeners() {
		$("[data-integration-type]").on("click", e => {
			const integrationType = $(e.target).data("integration-type") as IntegrationType;
			// fire a global event and a specific event for the integration type
			Integrations.triggerAddIntegrationEvent(integrationType);
			this.modal.close();
		});
	}

	private resetDialog() {
		$(`[data-integration-type]`).show();
		$(`[aria-added]`).hide();
	}
}
